import Vue from 'vue'
import errors from '@/store/errors'
import { METHODS } from '@/const'

const vue = Vue.prototype
const actions = {
	getProjectsStatisticsData: async function ({ state, commit, getters, rootState }, input) {
		commit('setProjectsStatisticsData', [])
		try {
			const result = await rootState.request({
				type: METHODS.GET,
				apiName: 'hqsw',
				url: 'bridge/seowork/projects/statistics',
				auth: true,
				query: input?.query
			})

			if (result.has_data && result.data) {
				commit('setProjectsStatisticsData', result.data)
				return result.data
			}
		} catch (e) {
			vue.$notify({ type: 'error', title: errors.GET_DATA })
			return false
		}
	}
}

export default actions
